import React from 'react';
import {Form} from "react-bootstrap";

const SiteOption = ({label, desc, icon, disabled, trial, checked, onChange, children}) => (<div className="mt-3">
  <div className="flex w-100">
    <div className="flex-grow-1 d-flex">
      <img className="me-3 mt-1 op-6" src={`assets/icons/${icon}`} height={20} />
      <div>
        <div>
          {label}
          {trial && <img className="ms-1 opacity-50" alt="Pro" src="assets/icons/pro-black.png" height="20"/>}
        </div>
        <div className="font-small grey">{desc}</div>
      </div>
    </div>
    <Form.Check
      className="text-align-end"
      checked={checked}
      type="switch"
      onChange={onChange}
      disabled={trial || disabled}
    />
  </div>
  {checked && children}
</div>)

export default SiteOption;